import React from "react";
// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
//import GitHubIcon from "@mui/icons-material/GitHub";
import YouTubeIcon from "@mui/icons-material/YouTube";

// Material Kit 2 React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/favicon.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "Kunta.live",
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "https://www.facebook.com/KuntaLive/",
    },
    {
      icon: <TwitterIcon />,
      link: "https://x.com/KuntaLive",
    },
    {
      icon: <YouTubeIcon />,
      link: "https://www.youtube.com/channel/",
    },
  ],
  menus: [
    {
      name: "bakgrund",
      items: [
        { name: "information", href: "/information" },
        { name: "mål", href: "/target" },
        { name: "scheman", href: "/schedule" },
      ],
    },
    {
      name: "resurser",
      items: [{ name: "Tammerfors universitet", href: "https://tuni.fi/" }],
    },
    {
      name: "Hjälp",
      items: [
        { name: "kontakta oss", href: "/contact" },
        { name: "instruktioner", href: "/instructions" },
        { name: "rapportera fel", href: "/bugs" },
        { name: "föreslå en ändring", href: "/contact" },
      ],
    },
    {
      name: "Lagar",
      items: [
        { name: "användarvillkor", href: "/termsofuse" },
        { name: "dataskydds", href: "/gdpr" },
        { name: "licenser", href: "license" },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date} Kunta.live by{" "}
      <MKTypography
        component="a"
        href="https://kunta.live"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        Osmo Leppäniemi
      </MKTypography>
      .
    </MKTypography>
  ),
};
